import {
    GET_ITEM_AND_ORDER_LEVEL_APPROVAL,
    SET_IS_ITEM_AND_ORDER_LEVEL_APPROVAL,
    GET_APPROVER_ACTIONS_DATA,
    SET_REQUEST_APPROVER_ACTIONS_DATA,
    GET_CAPITAL_LEASE_EXPENDITURE_DATA,
    SET_CAPITAL_LEASE_EXPENDITURE_DATA,
    SET_REQUISITION_APPROVAL_DATA,
    SET_QUANTITY_APPROVER_ACTIONS_DATA
} from "./ApprovalType"

const getItemAndOrderLevelApproval = (val : any) => ({
    type: GET_ITEM_AND_ORDER_LEVEL_APPROVAL,
    val
});

const setIsItemAndOrderLevelApproval = (isItemAndOrderLevelApprovalData: any) => ({
    type: SET_IS_ITEM_AND_ORDER_LEVEL_APPROVAL,
    isItemAndOrderLevelApprovalData: isItemAndOrderLevelApprovalData
});

const getApproverActionData = (val: any) => ({
    type: GET_APPROVER_ACTIONS_DATA,
    val
});

const setRequestApproverActionData = (requestApproverActionData: any) => ({
    type: SET_REQUEST_APPROVER_ACTIONS_DATA,
    requestApproverActionData: requestApproverActionData
});

const setQuantityApproverActionData = (quantityApproverActionData: any) => ({
    type: SET_QUANTITY_APPROVER_ACTIONS_DATA,
    quantityApproverActionData: quantityApproverActionData
});

const getCapitalLeaseExpenditureData = (val : any) => ({
    type: GET_CAPITAL_LEASE_EXPENDITURE_DATA,
    val
});

const setCapitalLeaseExpenditureData = (capitalLeaseExpenditureData: any) => ({
    type: SET_CAPITAL_LEASE_EXPENDITURE_DATA,
    capitalLeaseExpenditureData: capitalLeaseExpenditureData
});

const setRequisitionApprovalData = (requisitionApprovalData: any) => ({
    type: SET_REQUISITION_APPROVAL_DATA,
    requisitionApprovalData: requisitionApprovalData
})

export {
    getItemAndOrderLevelApproval,
    setIsItemAndOrderLevelApproval,
    getApproverActionData,
    setRequestApproverActionData,
    getCapitalLeaseExpenditureData,
    setCapitalLeaseExpenditureData,
    setRequisitionApprovalData,
    setQuantityApproverActionData
}
